const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: 'شغّل تعليمات برمجية مخصصة في نقاط محددة من تدفق المصادقة لتوسيع سلوك Logto.',
    status: {
        not_configured: 'غير مكوّن',
        configured: 'مكوّن',
        enabled: 'مفعّل',
        disabled: 'معطّل',
    },
    types: {
        post_first_factor_verification: {
            name: 'بعد التحقق من العامل الأول',
            description: 'شغّل منطقًا مخصصًا بعد فشل التحقق من كلمة المرور المحلية أثناء تسجيل الدخول.',
        },
        post_sign_in: {
            name: 'بعد تسجيل الدخول',
            description: 'شغّل منطقًا مخصصًا بعد تسجيل دخول المستخدم بنجاح.',
        },
    },
    data_source_tab: 'مصدر البيانات',
    test_tab: 'سياق الاختبار',
    settings_tab: 'الإعدادات',
    event_data: {
        title: 'حمولة الحدث',
        subtitle: 'استخدم معلمة الإدخال `event` لبيانات حدث المصادقة.',
    },
    result_data: {
        title: 'نتيجة الإجراء',
        subtitle: 'أرجع كائن نتيجة يفهمه Logto لهذا النوع من الإجراءات.',
    },
    environment_variables: {
        title: 'تعيين متغيرات البيئة',
        subtitle: 'استخدم متغيرات البيئة لتخزين المعلومات الحساسة.',
        input_field_title: 'إضافة متغيرات البيئة',
        sample_code: 'الوصول إلى متغيرات البيئة في معالج الإجراء. مثال:',
    },
    fetch_external_data: {
        title: 'جلب بيانات خارجية',
        subtitle: 'استدعِ واجهات API الخارجية من سكربت الإجراء.',
        description: 'استخدم الدالة `fetch` لاستدعاء واجهات API الخارجية وتضمين البيانات في نتيجة الإجراء. مثال:',
    },
    settings: {
        title: 'الإعدادات',
        subtitle: 'تحكّم فيما إذا كان الإجراء نشطًا وكيفية التعامل مع أخطاء وقت التشغيل.',
        enabled: {
            title: 'تفعيل الإجراء',
            description: 'شغّل هذا السكربت عند تشغيل حدث المصادقة.',
        },
        on_execution_error: {
            title: 'عند حدوث خطأ في السكربت',
            description: 'اختر كيف يجب أن يتصرف Logto عندما يفشل السكربت في وقت التشغيل.',
            block: 'حظر تدفق المصادقة',
            allow: 'السماح لتدفق المصادقة بالمتابعة',
            post_first_factor_description: 'عند فشل هذا السكربت، يرفض Logto دائمًا بيانات الاعتماد غير الصالحة حتى لا يمكن تجاوز التحقق من كلمة المرور.',
        },
    },
    test_context: {
        subtitle: 'اضبط حمولة الحدث الوهمية المستخدمة عند تشغيل الاختبارات.',
        input_field_title: 'JSON مثال للحدث',
    },
    script: {
        title: 'السكربت',
        restore: 'استعادة الإعدادات الافتراضية',
        restored: 'تمت الاستعادة',
    },
    tester: {
        run_button: 'تشغيل الاختبار',
        result_title: 'نتيجة الاختبار',
    },
    form_error: {
        invalid_json: 'تنسيق JSON غير صالح',
    },
    security_warning: {
        title: 'تحذير أمني',
        description: 'لا يعمل هذا الإجراء إلا بعد فشل التحقق من كلمة المرور المحلية. لا تُرجع `passwordVerified: true` إلا بعد التحقق بشكل مستقل من كلمة المرور المقدمة. يتجاوز المستخدمون الذين يُنشئهم هذا الإجراء القيود الخاصة بالتسجيل فقط، بما في ذلك قائمة حظر البريد الإلكتروني، ونطاق SSO فقط، ووضع تعطيل التسجيل، وفحوصات الملف الشخصي الإلزامي عند التسجيل. كما تحدث عمليات كتابة الملف الشخصي وكلمة المرور للمستخدمين الحاليين قبل اكتمال MFA.',
    },
    delete_modal_title: 'حذف الإجراء',
    delete_modal_content: 'هل أنت متأكد أنك تريد حذف هذا الإجراء؟ لن يشغّل تدفق المصادقة هذا السكربت بعد الآن.',
    deleted: 'تم حذف الإجراء',
    created: 'تم إنشاء الإجراء',
    saved: 'تم حفظ الإجراء',
};
export default Object.freeze(actions);
